import { render } from "./SplitOrderModal.vue?vue&type=template&id=3da99e7d&scoped=true"
import script from "./SplitOrderModal.vue?vue&type=script&lang=js"
export * from "./SplitOrderModal.vue?vue&type=script&lang=js"

import "./SplitOrderModal.vue?vue&type=style&index=0&id=3da99e7d&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3da99e7d"]])

export default __exports__